export default "__VITE_ASSET__N8gdGaVyOLPWXNFayxWuYg__";